import { LinkEntity } from 'src/app/domain/entities/link.entitty';

/**
 * Ícone por tipo de campo, exibido na lista de autocomplete do `@`.
 * A chave é o sufixo da tag (`link_client_email` → `email`), então uma tag nova
 * de um tipo já conhecido herda o ícone sem precisar de cadastro aqui.
 */
const FIELD_ICONS: Record<string, string> = {
    name: 'profile',
    contact_name: 'profile',
    document: 'file',
    email: 'email',
    phone: 'mobile',
    address: 'home',
    title: 'text',
    updated_at: 'calendar',
};

/** Ícone por categoria, usado quando o sufixo do campo é desconhecido. */
const CATEGORY_ICONS: Record<string, string> = {
    client: 'profile',
    company: 'building',
    document: 'document-normal',
};

const FALLBACK_ICON = 'document-normal';

/** `$link_client_email` / `LINK_CLIENT_EMAIL` → `link_client_email` */
function normalizeTag(link: LinkEntity): string {
    const raw = link.value ?? link.tagName ?? link.name ?? '';
    return raw.replace(/^\$/, '').trim().toLowerCase();
}

/**
 * Nome do ícone (`public/icons/<nome>.svg`) do link.
 * Resolve pelo tipo do campo; sem correspondência, cai na categoria e depois
 * no ícone genérico — nunca lança nem devolve vazio.
 */
export function getLinkCategoryIcon(link: LinkEntity): string {
    const tag = normalizeTag(link);
    const category = link.category?.trim().toLowerCase();

    // `link_client_contact_name` → tenta `contact_name`, depois `name`
    if (tag) {
        const withoutPrefix = tag.startsWith('link_') ? tag.slice(5) : tag;
        const parts = withoutPrefix.split('_').filter(Boolean);
        for (let i = category && parts[0] === category ? 1 : 0; i < parts.length; i++) {
            const suffix = parts.slice(i).join('_');
            if (FIELD_ICONS[suffix]) return FIELD_ICONS[suffix];
        }
    }

    if (category && CATEGORY_ICONS[category]) return CATEGORY_ICONS[category];
    return FALLBACK_ICON;
}
